import Layout from '@/layouts/Layout'

const group = {
  path: '/tenant_new',
  component: Layout,
  name: 'tenant_new',
  meta: {
    title: '集团',
  },
  children: [
    {
      path: '/tenant/companyInformation/list',
      name: 'tenant_new_company',
      component: () => import('@/pages/organize/companyInformation/list/index'),
      meta: { title: '公司信息管理', logEvent: '' },
    },
    {
      path: '/tenant/employeeAccount/list',
      name: 'tenant_new_company_account',
      component: () => import('@/pages/organize/employeeAccount/list/index'),
      meta: { title: '公司员工账号管理', logEvent: '' },
    },
    {
      path: '/tenant/companyInformation/detail',
      name: 'tenant_new_company_list_detail',
      component: () => import('@/pages/organize/companyInformation/detail/index'),
      meta: { title: '公司信息管理详情', logEvent: '' },
    },
    {
      path: '/tenant/companyInformation/add',
      name: 'tenant_new_company_list_create',
      component: () => import('@/pages/organize/companyInformation/add/index'),
      meta: { title: '公司信息管理新增',
        logEvent: '',
        parent: [
          {
            path: '/tenant/companyInformation/list',
            name: 'tenant_new_company',
            title: '公司信息管理',
          },
        ] },
    },
    {
      path: '/tenant/companyInformation/edit',
      name: 'tenant_new_company_list_edit',
      component: () => import('@/pages/organize/companyInformation/edit/index'),
      meta: { title: '公司信息管理编辑',
        logEvent: '',
        parent: [
          {
            path: '/tenant/companyInformation/list',
            name: 'tenant_new_company',
            title: '公司信息管理',
          },
        ] },
    },
    {
      path: '/tenant/groupAccount/list',
      name: 'tenant_new_account',
      component: () => import('@/pages/organize/groupAccount/list/index'),
      meta: { title: '集团账号管理', logEvent: '' },
    },
    {
      path: '/tenant/groupRoleMange/list',
      name: 'tenant_new_role',
      component: () => import('@/pages/organize/groupRoleMange/list/index.vue'),
      meta: { title: '集团角色管理', logEvent: '' },
    },
    {
      path: '/tenant/groupApproveFlowConfig/list',
      name: 'tenant_new_approval_config',
      component: () => import('@/pages/approvals/groupApproveFlowConfig/list'),
      meta: { title: '审批流配置', logEvent: '' },
    },
    {
      path: '/tenant/groupApproveFlowConfig/detail',
      name: 'tenant_new_approval_config_list_detail',
      component: () => import('@/pages/approvals/groupApproveFlowConfig/detail'),
      meta: { title: '审批流详情', logEvent: '' },
    },
    {
      path: '/tenant/groupApproveFlowConfig/edit',
      name: 'tenant_new_approval_config_list_edit',
      component: () => import('@/pages/approvals/groupApproveFlowConfig/edit'),
      meta: { title: '审批流编辑', logEvent: '' },
    },
    {
      path: '/tenantNew/contractTemplate/list',
      name: 'tenant_new_contract_template',
      // component: () => import('@/pages/carsService/contractTemplate/list'),
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/index.vue'),
      meta: { title: '合同模板管理', logEvent: '' },
    },
    {
      path: '/tenantNew/contractTemplate/edit',
      name: 'tenant_new_contract_template_list_edit',
      // component: () => import('@/pages/carsService/contractTemplate/edit'),
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/edit.vue'),
      meta: { title: '合同模板编辑',
        logEvent: '',
        parent: [
          {
            path: '/tenantNew/contractTemplate/list',
            name: 'tenant_new_contract_template',
            title: '合同模板管理',
          },
        ] },
    },
    {
      path: '/tenantNew/contractTemplate/add',
      name: 'tenant_new_contract_template_list_create',
      // component: () => import('@/pages/carsService/contractTemplate/add'),
      component: () => import('@/pages/organize/Contract/views/ContractTemplateMangment/add.vue'),
      meta: { title: '合同模板新增',
        logEvent: '',
        parent: [
          {
            path: '/tenantNew/contractTemplate/list',
            name: 'tenant_new_contract_template',
            title: '合同模板管理',
          },
        ] },
    },
    // 网约运营数据共享[集团]
    {
      path: '/tenant/linkage/secret/list',
      name: 'linkage_board_config_secretList',
      component: () => import('@/pages/organize/linkage/secret/list'),
      meta: { title: '网约运营数据共享', logEvent: '' },
    },
    // e签宝配置
    {
      path: '/tenant/eSign/config/list',
      name: 'esign_config_list',
      component: () => import('@/pages/organize/eSign//list'),
      meta: { title: 'e签宝配置', logEvent: '' },
    },
    // e签宝使用明细
    {
      path: '/tenant/eSign/chargeRecord/list',
      name: 'chargeRecord',
      component: () => import('@/pages/organize/eSign/chargeRecordList'),
      meta: { title: '使用明细', logEvent: '' },
    },
  ],
}
export default group
